<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
	querycell,
	writesave,
	startShenBao,
	forShengcdg,
	manuscriptqueryReportStep,
	manuscriptwriteimport,
	manuscriptUploadFile,
	annexadd
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import valueAddedTax_I from './valueAddedTax_I/index.vue';
import { getdata as dataI } from './valueAddedTax_I/data.js';
import valueAddedTax_II from './valueAddedTax_II/index.vue';
import { getdata as dataII } from './valueAddedTax_II/data.js';
import valueAddedTax_III from './valueAddedTax_III/index.vue';
import { getdata as dataIII } from './valueAddedTax_III/data.js';
import valueAddedTax_IIII from './valueAddedTax_IIII/index.vue';
import { getdata as dataIIII } from './valueAddedTax_IIII/data.js';
export default {
	name: '',
	components: {
		minhead,
		SalesTaxReportTree,
		SalesTaxReportbox,
		uploadFile,
		uploadFileplus,
		addzc,
		seezc,
		valueAddedTax_I,
		valueAddedTax_II,
		valueAddedTax_III,
		valueAddedTax_IIII
	},
	props: {
		seeNow: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ''
		},
		suosq: {
			type: String,
			default: ''
		},
		params: {
			type: Object,
			default: {}
		},
		sbqj: {
			type: String,
			default: ''
		},
		showbox: {
			type: Boolean,
			default: false
		},
		mintext: {
			type: String,
			default: '填写'
		},
		toseeUpdate: {
			type: Boolean,
			default: false
		}
	},

	mounted() {
		if (this.toseeUpdate) {
			this.getShuibDetailList();
		} else {
			this.manuscriptqueryReportStep();
		}
	},
	data: function() {
		return {
			treestate: '',
			statedata: [],
			treedata: getdata().treedata,
			choosetitleindex: '',
			formlist: getdata().formlist,
			headobj: {},
			choosecellCode: '',
			smtext: '',
			zcdata: [],
			Changed:0,
			searchlistzc: getdata().searchlistzc,
			headDatazc: getdata().headDatazc,
			pagination: getdata().pagination,
			seezcformlist: getdata().seezcformlist,
			formdatazc: getdata().formdatazc, //form表单数据
			tableDataIx: [],
			tableDataI: [],
			tableDataII: [],
			tableDataIII: [],
			tableDataIIII: [],
			tableDataIIIII: [],
			ZeroHead: ['zzsxgm_0_x_1', 'zzsxgm_0_x_2', 'zzsxgm_0_x_3', 'zzsxgm_0_x_4'],
			IHead: ['zzsxgm_1_x_1', 'zzsxgm_1_x_2', 'zzsxgm_1_x_3', 'zzsxgm_1_x_4'],
			IIHead: [
				'zzsxgm_2_x_1',
				'zzsxgm_2_x_2',
				'zzsxgm_2_x_3',
				'zzsxgm_2_x_4',
				'zzsxgm_2_x_5',
				'zzsxgm_2_x_6',
				'zzsxgm_2_x_7',
				'zzsxgm_2_x_8',
				'zzsxgm_2_x_9',
				'zzsxgm_2_x_10'
			],
			TaxHead:[
				"zzsxgm_3_x_1",
				"zzsxgm_3_x_2",
				"zzsxgm_3_x_3",
				"zzsxgm_3_x_4",
				"zzsxgm_3_x_5",
				"zzsxgm_3_x_0",
			],
			choosetable: '',
			chooseindex: '',
			choosecolum: '',
			errarr: [],
			errdiag: false
		};
	},
	methods: {
		zcsclick(id) {
			this.$refs.boxref.zcsclick(id);
		},
		forhover(table, colum, index) {
			this.$refs.boxref.forhover(table, colum, index);
		},
		inputjin(e) {
			this.headobj = e;
		},
		getchoosecellCode(table, colum, index) {

            console.log(111111111111111111111)
			if (this.$emptyandnull(table)) {
				this.choosecellCode = '';
				return false;
			}
			this.choosetable = table;
			this.chooseindex = index;
			this.choosecolum = colum;
			this.choosecellCode = this[table][index][colum].cellCode;
			if (this.toseeUpdate) {
				this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
				this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
			} else {
				this.smtext = this[table][index][colum]['updateDesc'] || '';
			}
		},
		//更正说明
		forgengzheng(table, colum, index, smtext) {
			this[table][index][colum]['updateDesc'] = smtext;
		},
		//更正政策和说明
		forxzsm(table, colum, index, smtext, zcdata) {
			this[table][index][colum]['map'] = {
				desc: '',
				zcs: []
			};
			this[table][index][colum]['map']['desc'] = smtext;
			this[table][index][colum]['map']['zcs'] = zcdata;
		},
		//点击全部范围
		refreshhover() {
			this.$nextTick(() => {
				this.$refs.boxref.refreshhover();
			});
		},
		getShuibDetailList() {
			getShuibDetailList({
				shuizId: this.params.shuizId,
				id: this.params.id
			}).then(res => {
				if (res.data.code == 1) {
					this.treedata = res.data.data;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		manuscriptqueryReportStep() {
			manuscriptqueryReportStep({
				id: this.params.id,
				sbbm: this.params.sbbm
			}).then(res => {
				if (res.data.code == 1) {
					this.statedata = res.data.data.statusHistory;
					this.treedata = res.data.data.detail;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		getchoosetitleindex(item) {
			this.choosetitleindex = item.shuibNameCode;
		},
		forback() {
			if(this.Changed>0){
					this.$showConfirm({
						message: "是否不保存当前修改?",
						title:"您还未保存",
					}).then((res) => {
						if (res == "confirm") {
							this.$emit('forback', true);
						}else{
							//取消
						}
					});
			}else{
				this.$emit('forback', true);
			}
		},
		changestate(e) {
			this.treestate = e;
		},
		filternums(data, filterlist) {
			var newlist = [];
			filterlist.forEach(ytem => {
				let newval = data.map(item => {
					if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(item[ytem] && item[ytem].cellVal != null)) {
						return item[ytem];
					} else {
						return 'x';
					}
				});
				newlist = [...newlist, ...newval].filter(gtem => gtem != 'x');
			});
			return newlist;
		},
		refreshtableDataI() {
			this.tableDataI.forEach((item, index) => {
				this.ZeroHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
		},
		refreshtableDataII() {
			this.tableDataII.forEach((item, index) => {
				this.IHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
		},
		//重置附表三
		refreshtableDataIII() {
			this.tableDataIII.forEach((item, index) => {
				this.IIHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
		},
		//重置减免税申报表
		refreshtableDataIIII() {
			this.tableDataIIII.forEach((item, index) => {
				this.TaxHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
			this.tableDataIIIII.forEach((item, index) => {
				this.TaxHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});

		},
		commanddcrefresh(e) {
			this.Changed++
			if (e == 'now') {
				if (this.choosetitleindex == 'zzsxgm_0') {
					this.refreshtableDataI();
				}
				if (this.choosetitleindex == 'zzsxgm_1') {
					this.refreshtableDataII();
				}
				if (this.choosetitleindex == 'zzsxgm_2') {
					this.refreshtableDataIII();
				}
				if (this.choosetitleindex == 'zzsxgm_3') {
					this.refreshtableDataIIII();
				}
			}
			if (e == 'all') {
				Object.keys(this.headobj).map(key => (this.headobj[key] = ''));
				this.refreshtableDataI();
				this.refreshtableDataII();
				this.refreshtableDataIII();
				this.refreshtableDataIIII();
			}
		},
		//所有表格渲染
		querycell(index) {
			//编辑格子查询
			if (this.type == 'update') {
				querycell({
					companyNo: this.params.companyNo, // 公司编号
					id: this.params.id, //报表id
					shuibId: this.params.shuibId, //税种id
					sbbm: this.params.sbbm
				}).then(res => {
					let dataarr = res.data.data;
					this.gettable(dataarr);
				});
			}
			if (this.type == 'tosee') {
				if (this.seeNow) {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
					return false;
				}
				if (this.toseeUpdate) {
					querytemplatecell({
						shuibId: this.params.id,
						id: this.params.id
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				} else {
					reportquerytrack({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm,
						trackId: this.params.trackId
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
			}
		},
		gettable(dataarr) {
            console.log(dataarr);
			this.headobj = dataarr.head;
			//主表
			dataarr.zzsxgm_0[24].zzsxgm_0_x_3 = {
				cellType: '0'
			};
			dataarr.zzsxgm_0[24].zzsxgm_0_x_4 = {
				cellType: '0'
			};
			dataarr.zzsxgm_0[25].zzsxgm_0_x_3 = {
				cellType: '0'
			};
			dataarr.zzsxgm_0[25].zzsxgm_0_x_4 = {
				cellType: '0'
			};
			dataarr.zzsxgm_0[26].zzsxgm_0_x_3 = {
				cellType: '0'
			};
			dataarr.zzsxgm_0[26].zzsxgm_0_x_4 = {
				cellType: '0'
			};
			var newtabledataZero = dataarr.zzsxgm_0;
			var realtableDataZero = dataI().tableData;
			realtableDataZero.forEach((item, index) => {
				if (newtabledataZero[index]) {
					this.ZeroHead.forEach(gtem => {
						item[gtem] = newtabledataZero[index][gtem];
					});
				}
			});
			this.tableDataI = realtableDataZero;
			//附表一
			var newtabledataI = dataarr.zzsxgm_1;
			var realtableDataI = dataII().tableData;

			realtableDataI.forEach((item, index) => {
				if ((index + 1) % 4 == 0) {
					if (newtabledataI[0]) {
						this.IHead.forEach((gtem, index1) => {
							item[gtem] = newtabledataI[0][`zzsxgm_1_x_${index1 + (index - 2)}`];
						});
					}
				}
			});
			this.tableDataII = realtableDataI;
			var newtabledataII = dataarr.zzsxgm_2;
			var realtableDataII_I = dataIII().tableData;
			realtableDataII_I.forEach((item, index) => {
				if (newtabledataII[index]) {
					this.IIHead.forEach(gtem => {
						item[gtem] = newtabledataII[index][gtem];
					});
				}
			});

			this.tableDataIII = realtableDataII_I;

			this.tableDataIII.forEach(item => {
				if (item.zzsxgm_2_x_3 && item.zzsxgm_2_x_3.cellVal != '- -') {
					item.zzsxgm_2_x_3.cellVal = item.zzsxgm_2_x_3.cellVal == '' ? '0' : `${this.$numMulti(item.zzsxgm_2_x_3.cellVal, 100)}`;
				}
				if (item.zzsxgm_2_x_7 && item.zzsxgm_2_x_7.cellVal != '- -') {
					item.zzsxgm_2_x_7.cellVal = item.zzsxgm_2_x_7.cellVal == '' ? '0' : `${this.$numMulti(item.zzsxgm_2_x_7.cellVal, 100)}`;
				}
			});


			//增值税减免税申报明细表
			if (this.$notemptyandnull(dataarr.zzsxgm_3)) {
				var newtabledataTax = dataarr.zzsxgm_3;
				var newtabledataTax_I = newtabledataTax.filter((item, index) => index < 6);
				var realtableDataTax_I = dataIIII().tableDataIX;
				realtableDataTax_I.forEach((item, index) => {
					if (newtabledataTax_I[index]) {
						this.TaxHead.forEach((gtem) => {
							item[gtem] = newtabledataTax_I[index][gtem] || '';
						});
					}
				});
				this.tableDataIIII = realtableDataTax_I;
				var newtabledataTax_II = newtabledataTax.filter((item, index) => index > 5);
				var realtableDataTax_II = dataIIII().tableDataIXX;
				realtableDataTax_II.forEach((item, index) => {
					if (newtabledataTax_II[index]) {
						this.TaxHead.forEach((gtem) => {
							item[gtem] = newtabledataTax_II[index][gtem] || '';
						});
					}
				});
				this.tableDataIIIII = realtableDataTax_II;
			}

		},
		checkerror() {
			let arr = [];
			if (this.gettableval('zzsxgm_0_7_1', 'tableDataI') < this.gettableval('zzsxgm_0_8_1', 'tableDataci')) {
				arr.push('附加税费申报表第7栏次第1列 应满足条件:附加税费申报表第7栏次第1列>=附加税费申报表第8栏次第1列');
			}
			if (this.gettableval('zzsxgm_0_13_1', 'tableDataI') < this.gettableval('zzsxgm_0_14_1', 'tableDataci')) {
				arr.push('附加税费申报表第13栏次第1列 应满足条件:附加税费申报表第13栏次第1列>=附加税费申报表第14栏次第1列');
			}
			if (this.gettableval('zzsxgm_0_13_2', 'tableDataI') < this.gettableval('zzsxgm_0_14_2', 'tableDataci')) {
				arr.push('附加税费申报表第13栏次第2列 应满足条件:附加税费申报表第13栏次第2列>=附加税费申报表第14栏次第2列');
			}
			if (this.gettableval('zzsxgm_0_18_1', 'tableDataI') > this.gettableval('zzsxgm_0_17_1', 'tableDataci')) {
				this.changetableval('zzsxgm_0_18_1', 'tableDataIII', this.gettableval('zzsxgm_0_17_2', 'tableDataI'));
			}
            if (this.gettableval("zzsxgm_3_2_4","tableDataIIII") <= this.gettableval("zzsxgm_3_2_3","tableDataIIII")) {
                arr.push('增值税减免税申报明细表一、减税项目 第2栏次第4列 应满足条件:本期实际抵减税额<=本期应抵减税额');
            }
            if (this.gettableval("zzsxgm_3_3_4","tableDataIIII") <= this.gettableval("zzsxgm_3_3_3","tableDataIIII")) {
                arr.push('增值税减免税申报明细表一、减税项目 第3栏次第4列 应满足条件:本期实际抵减税额<=本期应抵减税额');
            }
            if (this.gettableval("zzsxgm_3_4_4","tableDataIIII") <= this.gettableval("zzsxgm_3_4_3","tableDataIIII")) {
                arr.push('增值税减免税申报明细表一、减税项目 第4栏次第4列 应满足条件:本期实际抵减税额<=本期应抵减税额');
            }
            if (this.gettableval("zzsxgm_3_5_4","tableDataIIII") <= this.gettableval("zzsxgm_3_5_3","tableDataIIII")) {
                arr.push('增值税减免税申报明细表一、减税项目 第5栏次第4列 应满足条件:本期实际抵减税额<=本期应抵减税额');
            }
            if (this.gettableval("zzsxgm_3_6_4","tableDataIIII") <= this.gettableval("zzsxgm_3_6_3","tableDataIIII")) {
                arr.push('增值税减免税申报明细表一、减税项目 第6栏次第4列 应满足条件:本期实际抵减税额<=本期应抵减税额');
            }
			if (arr.length > 0) {
				this.errarr = arr;
				this.errdiag = true;
				return false;
			} else {
				return true;
			}
		},
		forsave() {
			let status = this.checkerror();
			const newarr = [
				...this.filternums(this.tableDataI, this.ZeroHead),
				...this.filternums(this.tableDataII, this.IHead),
				...this.filternums(this.tableDataIII, this.IIHead),
				...this.filternums(this.tableDataIIII, this.TaxHead),
				...this.filternums(this.tableDataIIIII, this.TaxHead)
			];
			newarr.forEach(item => {
				if (item.cellCode && ['zzsxgm_2_1_3', 'zzsxgm_2_2_3', 'zzsxgm_2_3_3', 'zzsxgm_2_4_3'].includes(item.cellCode) && item.cellVal != '- -') {
					item.cellVal = item.cellVal * (0.01).toFixed(2);
				}
				if (item.cellCode && ['zzsxgm_2_1_7', 'zzsxgm_2_2_7', 'zzsxgm_2_3_7','zzsxgm_2_4_7'].includes(item.cellCode) && item.cellVal != '- -') {
					item.cellVal = item.cellVal * (0.01).toFixed(2);
				}
			});
			let params = {
				cells: newarr,
				companyNo: this.params.companyNo,
				id: this.params.id,
				sbbm: this.params.sbbm,
				head: this.headobj,
				checkFlag: status
			};
			writesave(params).then(res => {
				if (res.data.code == 1) {
					this.Changed = 0
					this.querycell();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		inputblur(e) {
			this.Changed++
			if (
				parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
			) {
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
			}
			if (e.cellCode == 'zzsxgm_2_1_9') {
				this.changetableval('zzsxgm_0_23_1', 'tableDataI', this.gettableval('zzsxgm_2_1_9', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_2_2_9') {
				this.changetableval('zzsxgm_0_24_1', 'tableDataI', this.gettableval('zzsxgm_2_2_9', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_0_10_1') {
				this.changetableval(
					'zzsxgm_0_9_1',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_1', 'tableDataI') + this.gettableval('zzsxgm_0_11_1', 'tableDataI') + this.gettableval('zzsxgm_0_12_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_10_2') {
				this.changetableval(
					'zzsxgm_0_9_2',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_2', 'tableDataI') + this.gettableval('zzsxgm_0_11_2', 'tableDataI') + this.gettableval('zzsxgm_0_12_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_11_1') {
				this.changetableval(
					'zzsxgm_0_9_1',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_1', 'tableDataI') + this.gettableval('zzsxgm_0_11_1', 'tableDataI') + this.gettableval('zzsxgm_0_12_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_11_2') {
				this.changetableval(
					'zzsxgm_0_9_2',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_2', 'tableDataI') + this.gettableval('zzsxgm_0_11_2', 'tableDataI') + this.gettableval('zzsxgm_0_12_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_12_1') {
				this.changetableval(
					'zzsxgm_0_9_1',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_1', 'tableDataI') + this.gettableval('zzsxgm_0_11_1', 'tableDataI') + this.gettableval('zzsxgm_0_12_1', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_12_2') {
				this.changetableval(
					'zzsxgm_0_9_2',
					'tableDataI',
					this.gettableval('zzsxgm_0_10_2', 'tableDataI') + this.gettableval('zzsxgm_0_11_2', 'tableDataI') + this.gettableval('zzsxgm_0_12_2', 'tableDataI')
				);
			}
			if (e.cellCode == 'zzsxgm_0_22_1') {
				this.changetableval('zzsxgm_0_24_1', 'tableDataI', this.gettableval('zzsxgm_0_22_1', 'tableDataI') - this.gettableval('zzsxgm_0_23_1', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_0_22_2') {
				this.changetableval('zzsxgm_0_24_2', 'tableDataI', this.gettableval('zzsxgm_0_22_2', 'tableDataI') - this.gettableval('zzsxgm_0_23_2', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_0_24_1') {
				this.changetableval('zzsxgm_2_1_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
				this.changetableval('zzsxgm_2_2_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
				this.changetableval('zzsxgm_2_3_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_0_24_2') {
				this.changetableval('zzsxgm_2_1_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
				this.changetableval('zzsxgm_2_2_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
				this.changetableval('zzsxgm_2_3_1', 'tableDataIII', this.gettableval('zzsxgm_0_22_1', 'tableDataI') + this.gettableval('zzsxgm_0_24_2', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_1_1_1') {
				this.changetableval(
					'zzsxgm_1_1_4',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_1', 'tableDataII') + this.gettableval('zzsxgm_1_1_2', 'tableDataII') - this.gettableval('zzsxgm_1_1_3', 'tableDataII')
				);
			}
			if (e.cellCode == 'zzsxgm_1_1_2') {
				this.changetableval(
					'zzsxgm_1_1_4',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_1', 'tableDataII') + this.gettableval('zzsxgm_1_1_2', 'tableDataII') - this.gettableval('zzsxgm_1_1_3', 'tableDataII')
				);
			}
			if (e.cellCode == 'zzsxgm_1_1_3') {
				this.changetableval(
					'zzsxgm_1_1_4',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_1', 'tableDataII') + this.gettableval('zzsxgm_1_1_2', 'tableDataII') - this.gettableval('zzsxgm_1_1_3', 'tableDataII')
				);
				this.changetableval('zzsxgm_1_1_6', 'tableDataII', this.gettableval('zzsxgm_1_1_3', 'tableDataII'));
			}
			if (e.cellCode == 'zzsxgm_1_1_5') {
				this.changetableval('zzsxgm_1_1_7', 'tableDataI', this.gettableval('zzsxgm_1_1_5', 'tableDataII') - this.gettableval('zzsxgm_1_1_6', 'tableDataI'));
			}
			if (e.cellCode == 'zzsxgm_1_1_6') {
				this.changetableval('zzsxgm_1_1_7', 'tableDataII', this.gettableval('zzsxgm_1_1_5', 'tableDataII') - this.gettableval('zzsxgm_1_1_6', 'tableDataII'));
			}
			if (e.cellCode == 'zzsxgm_1_1_7') {
				this.changetableval('zzsxgm_1_1_8', 'tableDataII', this.gettableval('zzsxgm_1_1_7', 'tableDataII') / 1.03);
			}
			if (e.cellCode == 'zzsxgm_1_1_9') {
				this.changetableval(
					'zzsxgm_1_1_12',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_9', 'tableDataII') + this.gettableval('zzsxgm_1_1_10', 'tableDataII') - this.gettableval('zzsxgm_1_1_11', 'tableDataII')
				);
			}
			if (e.cellCode == 'zzsxgm_1_1_10') {
				this.changetableval(
					'zzsxgm_1_1_12',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_9', 'tableDataII') + this.gettableval('zzsxgm_1_1_10', 'tableDataII') - this.gettableval('zzsxgm_1_1_11', 'tableDataII')
				);
			}
			if (e.cellCode == 'zzsxgm_1_1_11') {
				this.changetableval(
					'zzsxgm_1_1_12',
					'tableDataII',
					this.gettableval('zzsxgm_1_1_9', 'tableDataII') + this.gettableval('zzsxgm_1_1_10', 'tableDataII') - this.gettableval('zzsxgm_1_1_11', 'tableDataII')
				);
				this.changetableval('zzsxgm_1_1_14', 'tableDataII', this.gettableval('zzsxgm_1_1_11', 'tableDataII'));
			}
			if (e.cellCode == 'zzsxgm_1_1_13') {
				this.changetableval('zzsxgm_1_1_15', 'tableDataII', this.gettableval('zzsxgm_1_1_13', 'tableDataII') - this.gettableval('zzsxgm_1_1_14', 'tableDataII'));
			}
			if (e.cellCode == 'zzsxgm_1_1_14') {
				this.changetableval('zzsxgm_1_1_15', 'tableDataII', this.gettableval('zzsxgm_1_1_13', 'tableDataII') - this.gettableval('zzsxgm_1_1_14', 'tableDataII'));
			}
			if (e.cellCode == 'zzsxgm_1_1_15') {
				this.changetableval('zzsxgm_1_1_16', 'tableDataII', this.gettableval('zzsxgm_1_1_15', 'tableDataII') / 1.05);
			}
			if (e.cellCode == 'zzsxgm_2_1_1') {
				this.changetableval(
					'zzsxgm_2_1_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_1_1', 'tableDataIII') + this.gettableval('zzsxgm_2_1_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_1_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_1') {
				this.changetableval(
					'zzsxgm_2_2_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_2_1', 'tableDataIII') + this.gettableval('zzsxgm_2_2_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_2_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_1') {
				this.changetableval(
					'zzsxgm_2_3_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_3_1', 'tableDataIII') + this.gettableval('zzsxgm_2_3_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_3_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_2') {
				this.changetableval(
					'zzsxgm_2_1_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_1_1', 'tableDataIII') + this.gettableval('zzsxgm_2_1_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_1_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_2') {
				this.changetableval(
					'zzsxgm_2_2_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_2_1', 'tableDataIII') + this.gettableval('zzsxgm_2_2_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_2_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_2') {
				this.changetableval(
					'zzsxgm_2_3_4',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_3_1', 'tableDataIII') + this.gettableval('zzsxgm_2_3_2', 'tableDataIII')) * this.gettableval('zzsxgm_2_3_3', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_3') {
				this.changetableval(
					'zzsxgm_2_4_3',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_3', 'tableDataIII') + this.gettableval('zzsxgm_2_2_3', 'tableDataIII') + this.gettableval('zzsxgm_2_3_3', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_3') {
				this.changetableval(
					'zzsxgm_2_4_3',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_3', 'tableDataIII') + this.gettableval('zzsxgm_2_2_3', 'tableDataIII') + this.gettableval('zzsxgm_2_3_3', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_3') {
				this.changetableval(
					'zzsxgm_2_4_3',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_3', 'tableDataIII') + this.gettableval('zzsxgm_2_2_3', 'tableDataIII') + this.gettableval('zzsxgm_2_3_3', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_4') {
				this.changetableval(
					'zzsxgm_2_1_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_1_4', 'tableDataIII') - this.gettableval('zzsxgm_2_1_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_1_7', 'tableDataIII')) / 100
				);
				this.changetableval(
					'zzsxgm_2_1_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_4') {
				this.changetableval(
					'zzsxgm_2_2_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_2_4', 'tableDataIII') - this.gettableval('zzsxgm_2_2_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_2_7', 'tableDataIII')) / 100
				);
				this.changetableval(
					'zzsxgm_2_2_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_2_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_4') {
				this.changetableval(
					'zzsxgm_2_3_8',
					'tableDataIII',
					(this.gettableval('zzsxgm_2_3_4', 'tableDataIII') - this.gettableval('zzsxgm_2_3_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_3_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_3_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_6') {
				this.changetableval(
					'zzsxgm_2_1_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_1_4', 'tableDataIII') - this.gettableval('zzsxgm_2_1_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_1_7', 'tableDataIII')) / 100
				);
				this.changetableval(
					'zzsxgm_2_1_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_6',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_6', 'tableDataIII') + this.gettableval('zzsxgm_2_2_6', 'tableDataIII') + this.gettableval('zzsxgm_2_3_6', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_6') {
				this.changetableval(
					'zzsxgm_2_2_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_2_4', 'tableDataIII') - this.gettableval('zzsxgm_2_2_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_2_7', 'tableDataIII')) / 100
				);
				this.changetableval(
					'zzsxgm_2_2_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_2_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_6',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_6', 'tableDataIII') + this.gettableval('zzsxgm_2_2_6', 'tableDataIII') + this.gettableval('zzsxgm_2_3_6', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_6') {
				this.changetableval(
					'zzsxgm_2_3_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_3_4', 'tableDataIII') - this.gettableval('zzsxgm_2_3_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_3_9', 'tableDataIII')) / 100
				);
				this.changetableval(
					'zzsxgm_2_3_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_3_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_6',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_6', 'tableDataIII') + this.gettableval('zzsxgm_2_2_6', 'tableDataIII') + this.gettableval('zzsxgm_2_3_6', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_7') {
				this.changetableval(
					'zzsxgm_2_3_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_3_4', 'tableDataIII') - this.gettableval('zzsxgm_2_3_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_3_7', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_7') {
				this.changetableval(
					'zzsxgm_2_2_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_2_4', 'tableDataIII') - this.gettableval('zzsxgm_2_2_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_2_7', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_7') {
				this.changetableval(
					'zzsxgm_2_1_8',
					'tableDataIII',
					((this.gettableval('zzsxgm_2_1_4', 'tableDataIII') - this.gettableval('zzsxgm_2_1_6', 'tableDataIII')) * this.gettableval('zzsxgm_2_1_7', 'tableDataIII')) / 100
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_8') {
				this.changetableval(
					'zzsxgm_2_1_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_8',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_8', 'tableDataIII') + this.gettableval('zzsxgm_2_2_8', 'tableDataIII') + this.gettableval('zzsxgm_2_3_8', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_8') {
				this.changetableval(
					'zzsxgm_2_2_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_2_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_8',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_8', 'tableDataIII') - this.gettableval('zzsxgm_2_2_8', 'tableDataIII') + this.gettableval('zzsxgm_2_3_8', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_8') {
				this.changetableval(
					'zzsxgm_2_3_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_3_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_8',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_8', 'tableDataIII') + this.gettableval('zzsxgm_2_2_8', 'tableDataIII') + this.gettableval('zzsxgm_2_3_8', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_8') {
				this.changetableval(
					'zzsxgm_2_1_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_8',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_8', 'tableDataIII') + this.gettableval('zzsxgm_2_2_8', 'tableDataIII') + this.gettableval('zzsxgm_2_3_8', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_9') {
				this.changetableval('zzsxgm_0_25_1', 'tableDataI', this.gettableval('zzsxgm_2_1_9', 'tableDataIII'));
				this.changetableval(
					'zzsxgm_2_1_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_1_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_9',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_9', 'tableDataIII') + this.gettableval('zzsxgm_2_2_9', 'tableDataIII') + this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_9') {
				this.changetableval('zzsxgm_0_26_1', 'tableDataI', this.gettableval('zzsxgm_2_2_9', 'tableDataIII'));
				this.changetableval(
					'zzsxgm_2_2_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_2_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_2_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_9',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_9', 'tableDataIII') + this.gettableval('zzsxgm_2_2_9', 'tableDataIII') + this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_9') {
				this.changetableval('zzsxgm_0_27_1', 'tableDataI', this.gettableval('zzsxgm_2_3_9', 'tableDataIII'));
				this.changetableval(
					'zzsxgm_2_3_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_3_4', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_6', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_8', 'tableDataIII') -
						this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
				this.changetableval(
					'zzsxgm_2_4_9',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_9', 'tableDataIII') + this.gettableval('zzsxgm_2_2_9', 'tableDataIII') + this.gettableval('zzsxgm_2_3_9', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_1_10') {
				this.changetableval(
					'zzsxgm_2_4_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_10', 'tableDataIII') + this.gettableval('zzsxgm_2_2_10', 'tableDataIII') + this.gettableval('zzsxgm_2_3_10', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_2_10') {
				this.changetableval(
					'zzsxgm_2_4_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_10', 'tableDataIII') + this.gettableval('zzsxgm_2_2_10', 'tableDataIII') + this.gettableval('zzsxgm_2_3_10', 'tableDataIII')
				);
			}
			if (e.cellCode == 'zzsxgm_2_3_10') {
				this.changetableval(
					'zzsxgm_2_4_10',
					'tableDataIII',
					this.gettableval('zzsxgm_2_1_10', 'tableDataIII') + this.gettableval('zzsxgm_2_2_10', 'tableDataIII') + this.gettableval('zzsxgm_2_3_10', 'tableDataIII')
				);
			}
            if (e.cellCode == "zzsxgm_3_2_1") {
                this.changetableval(
                    "zzsxgm_3_1_1",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_4_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_1", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_2_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_2_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_2_2') {
                this.changetableval(
                    "zzsxgm_3_1_2",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_2", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_2_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_2_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_2_3') {
                this.changetableval(
                    "zzsxgm_3_1_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") + this.gettableval("zzsxgm_3_3_3", "tableDataIIII") + this.gettableval("zzsxgm_3_4_3", "tableDataIIII") + this.gettableval("zzsxgm_3_5_3", "tableDataIIII") + this.gettableval("zzsxgm_3_6_3", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_2_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") - this.gettableval("zzsxgm_3_2_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_2_4') {
                this.changetableval(
                    "zzsxgm_3_2_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") - this.gettableval("zzsxgm_3_2_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_2_5') {
                this.changetableval(
                    "zzsxgm_3_1_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_5", "tableDataIIII") + this.gettableval("zzsxgm_3_3_5", "tableDataIIII") + this.gettableval("zzsxgm_3_4_5", "tableDataIIII") + this.gettableval("zzsxgm_3_5_5", "tableDataIIII") + this.gettableval("zzsxgm_3_6_5", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_3_1') {
                this.changetableval(
                    "zzsxgm_3_1_1",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_4_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_1", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_3_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_3_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_3_2') {
                this.changetableval(
                    "zzsxgm_3_1_2",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_2", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_3_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_3_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_3_3') {
                this.changetableval(
                    "zzsxgm_3_1_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") + this.gettableval("zzsxgm_3_3_3", "tableDataIIII") + this.gettableval("zzsxgm_3_4_3", "tableDataIIII") + this.gettableval("zzsxgm_3_5_3", "tableDataIIII") + this.gettableval("zzsxgm_3_6_3", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_3_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_3_3", "tableDataIIII") - this.gettableval("zzsxgm_3_3_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_3_4') {
                this.changetableval(
                    "zzsxgm_3_3_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_3_3", "tableDataIIII") - this.gettableval("zzsxgm_3_3_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_3_5') {
                this.changetableval(
                    "zzsxgm_3_1_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_5", "tableDataIIII") + this.gettableval("zzsxgm_3_3_5", "tableDataIIII") + this.gettableval("zzsxgm_3_4_5", "tableDataIIII") + this.gettableval("zzsxgm_3_5_5", "tableDataIIII") + this.gettableval("zzsxgm_3_6_5", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_4_1') {
                this.changetableval(
                    "zzsxgm_3_1_1",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_4_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_1", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_4_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_4_1", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_4_2') {
                this.changetableval(
                    "zzsxgm_3_1_2",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_2", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_4_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_4_1", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_4_3') {
                this.changetableval(
                    "zzsxgm_3_1_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") + this.gettableval("zzsxgm_3_3_3", "tableDataIIII") + this.gettableval("zzsxgm_3_4_3", "tableDataIIII") + this.gettableval("zzsxgm_3_5_3", "tableDataIIII") + this.gettableval("zzsxgm_3_6_3", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_4_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_4_3", "tableDataIIII") - this.gettableval("zzsxgm_3_4_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_4_4') {
                this.changetableval(
                    "zzsxgm_3_4_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_4_3", "tableDataIIII") - this.gettableval("zzsxgm_3_4_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_4_5') {
                this.changetableval(
                    "zzsxgm_3_1_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_5", "tableDataIIII") + this.gettableval("zzsxgm_3_3_5", "tableDataIIII") + this.gettableval("zzsxgm_3_4_5", "tableDataIIII") + this.gettableval("zzsxgm_3_5_5", "tableDataIIII") + this.gettableval("zzsxgm_3_6_5", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_5_1') {
                this.changetableval(
                    "zzsxgm_3_1_1",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_4_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_1", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_5_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_5_1", "tableDataIIII") + this.gettableval("zzsxgm_3_5_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_5_2') {
                this.changetableval(
                    "zzsxgm_3_1_2",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_2", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_5_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_5_1", "tableDataIIII") + this.gettableval("zzsxgm_3_5_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_5_3') {
                this.changetableval(
                    "zzsxgm_3_1_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") + this.gettableval("zzsxgm_3_3_3", "tableDataIIII") + this.gettableval("zzsxgm_3_4_3", "tableDataIIII") + this.gettableval("zzsxgm_3_5_3", "tableDataIIII") + this.gettableval("zzsxgm_3_6_3", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_5_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_5_3", "tableDataIIII") - this.gettableval("zzsxgm_3_5_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_5_4') {
                this.changetableval(
                    "zzsxgm_3_5_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_5_3", "tableDataIIII") - this.gettableval("zzsxgm_3_5_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_5_5') {
                this.changetableval(
                    "zzsxgm_3_1_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_5", "tableDataIIII") + this.gettableval("zzsxgm_3_3_5", "tableDataIIII") + this.gettableval("zzsxgm_3_4_5", "tableDataIIII") + this.gettableval("zzsxgm_3_5_5", "tableDataIIII") + this.gettableval("zzsxgm_3_6_5", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_6_1') {
                this.changetableval(
                    "zzsxgm_3_1_1",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_1", "tableDataIIII") + this.gettableval("zzsxgm_3_3_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_4_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_1", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_1", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_6_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_6_1", "tableDataIIII") + this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_6_2') {
                this.changetableval(
                    "zzsxgm_3_1_2",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_2", "tableDataIIII") + this.gettableval("zzsxgm_3_3_2", "tableDataIIII") + this.gettableval("zzsxgm_3_4_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_5_2", "tableDataIIII")+ this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_6_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_6_1", "tableDataIIII") + this.gettableval("zzsxgm_3_6_2", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_6_3') {
                this.changetableval(
                    "zzsxgm_3_1_3",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_3", "tableDataIIII") + this.gettableval("zzsxgm_3_3_3", "tableDataIIII") + this.gettableval("zzsxgm_3_4_3", "tableDataIIII") + this.gettableval("zzsxgm_3_5_3", "tableDataIIII") + this.gettableval("zzsxgm_3_6_3", "tableDataIIII")
                )
                this.changetableval(
                    "zzsxgm_3_6_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_6_3", "tableDataIIII") - this.gettableval("zzsxgm_3_6_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_6_4') {
                this.changetableval(
                    "zzsxgm_3_6_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_6_3", "tableDataIIII") - this.gettableval("zzsxgm_3_6_4", "tableDataIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_6_5') {
                this.changetableval(
                    "zzsxgm_3_1_5",
                    "tableDataIIII",
                    this.gettableval("zzsxgm_3_2_5", "tableDataIIII") + this.gettableval("zzsxgm_3_3_5", "tableDataIIII") + this.gettableval("zzsxgm_3_4_5", "tableDataIIII") + this.gettableval("zzsxgm_3_5_5", "tableDataIIII") + this.gettableval("zzsxgm_3_6_5", "tableDataIIII")
                )
            }

            if (e.cellCode == 'zzsxgm_3_10_1' || e.cellCode == 'zzsxgm_3_10_2') {
                this.changetableval(
                    "zzsxgm_3_10_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_10_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_10_2", "tableDataIIIII")
                )
            }

            if (e.cellCode == 'zzsxgm_3_11_1' || e.cellCode == 'zzsxgm_3_11_2') {
                this.changetableval(
                    "zzsxgm_3_11_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_11_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_11_2", "tableDataIIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_12_1' || e.cellCode == 'zzsxgm_3_12_2') {
                this.changetableval(
                    "zzsxgm_3_12_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_12_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_12_2", "tableDataIIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_13_1' || e.cellCode == 'zzsxgm_3_13_2') {
                this.changetableval(
                    "zzsxgm_3_13_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_13_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_13_2", "tableDataIIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_14_1' || e.cellCode == 'zzsxgm_3_14_2') {
                this.changetableval(
                    "zzsxgm_3_14_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_14_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_14_2", "tableDataIIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_15_1' || e.cellCode == 'zzsxgm_3_15_2') {
                this.changetableval(
                    "zzsxgm_3_15_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_15_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_15_2", "tableDataIIIII")
                )
            }
            if (e.cellCode == 'zzsxgm_3_16_1' || e.cellCode == 'zzsxgm_3_16_2') {
                this.changetableval(
                    "zzsxgm_3_16_3",
                    "tableDataIIIII",
                    this.gettableval("zzsxgm_3_16_1", "tableDataIIIII") - this.gettableval("zzsxgm_3_16_2", "tableDataIIIII")
                )
            }
		},
		gettableval(changecode, table, old) {
			var head = '';
			if (table == 'tableDataI') {
				head = 'ZeroHead';
			}
			if (table == 'tableDataII') {
				head = 'IHead';
			}
			if (table == 'tableDataIII') {
				head = 'IIHead';
			}
            if (table == 'tableDataIIII') {
                head = 'TaxHead';
            }
            if (table == 'tableDataIIIII') {
                head = 'TaxHead';
            }
			var a;
			if (this[table] && this[head]) {
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							this[table][i][this[head][j]].cellVal &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (old) {
								if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].goujgxValue);
								}
							} else {
								if (this[table][i][this[head][j]].cellVal == '- -') {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
								}
							}
							break;
						}
					}
				}
			}

			a = a || 0;
			return a;
		},
		changetableval(changecode, table, newval, checkq) {
			var newval = newval || 0;
			newval = this.toFixed(newval, 2);
			var head = '';
			if (table == 'tableDataI') {
				head = 'ZeroHead';
			}
			if (table == 'tableDataII') {
				head = 'IHead';
			}
			if (table == 'tableDataIII') {
				head = 'IIHead';
			}
            if (table == 'tableDataIIII') {
                head = 'TaxHead';
            }
            if (table == 'tableDataIIIII') {
                head = 'TaxHead';
            }
			for (let i = 0; i < this[table].length; i++) {
				for (let j = 0; j < this[head].length; j++) {
					if (
						this[table][i][this[head][j]] &&
						this[table][i][this[head][j]].cellCode &&
						typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
						typeof this[table][i][this[head][j]].cellVal != undefined &&
						this[table][i][this[head][j]].cellCode == changecode
					) {
						if (this[table][i][this[head][j]].cellVal != newval) {
							if (this.suosq.substring(4, 6) < 5 && checkq) {
								this[table][i][this[head][j]].cellVal = '';
							} else {
								this[table][i][this[head][j]].cellVal = newval + '';
							}
							this.inputblur({
								cellCode: changecode,
								cellVal: newval
							});
							break;
						}
					}
				}
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
